module.exports = "/assets/325ad2fa5bcac218bffeb2670205c9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3G.png
// module id = 1007
// module chunks = 0